import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    ChangeDeliveryDatePayloadT,
    ChangeOrderTakeDate,
    DispactherGetTakeOrderResponseT,
    DispatcherAutoAssignPayloadT,
    DispatcherGetCouriersReportsResponseT,
    DispatcherGetDeliveredInvoicesFileResponseT,
    DispatcherGetDeliveriesListResponseT,
    DispatcherGetOrdersWithoutAddressResponseT,
    DispatcherGetStatusesDeliveryListResponseT,
    DispatcherGetStatusesListResponseT,
    DispatcherGetTakeOrdersParamsConfigT,
    DispatcherGetTakeOrdersResponseT,
    DispatcherGetTakesListResponseT,
    DispatcherGetWaitListStatusesResponseT,
    DispatcherOrdersWithoutAddressParamsT,
    DispatcherSetOrderPayloadT,
    DispatcherSubmitCheckedOrdersPayloadT,
    DispatcherSubmitOrdersToDispatcherSectorPayloadT,
    DispatcherSubmitOrdersToSectorPayloadT,
    DispatcherSubmitOrderToCourierPayloadT,
    ListsParamsT,
} from '../types/dispatcher.types'

const TAKE_URL = '/cabinet/api/take_cargo'

export class DispatcherRepository {
    getTakeOrders(
        dispatcher_sector_id: number,
        config: DispatcherGetTakeOrdersParamsConfigT
    ): Promise<AxiosResponse<DispatcherGetTakeOrdersResponseT>> {
        return http.get(`/cabinet/api/dispatcher-admin/takes/orders`, {
            params: { dispatcher_sector_id, ...config, limit: 10000 },
        })
    }

    getTakeOrder(order_id: number): Promise<AxiosResponse<DispactherGetTakeOrderResponseT>> {
        return http.get(`/cabinet/api/dispatcher-admin/by-order/${order_id}`)
    }

    getStatuses(): Promise<AxiosResponse<DispatcherGetStatusesListResponseT>> {
        return http.get(`/cabinet/api/dispatcher-admin/take-statuses`)
    }

    getStatusesDelivery(): Promise<AxiosResponse<DispatcherGetStatusesDeliveryListResponseT>> {
        return http.get(`/cabinet/api/wait-list-statuses`, { params: { type: 2 } })
    }

    getOrdersWithoutAddress(
        params: DispatcherOrdersWithoutAddressParamsT
    ): Promise<AxiosResponse<DispatcherGetOrdersWithoutAddressResponseT>> {
        return http.get(`/cabinet/api/dispatcher-admin/takes/orders/coordinates-null`, { params })
    }

    setOrderAddress(
        sender_id: number,
        payload: DispatcherSetOrderPayloadT
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/senders/${sender_id}`, payload)
    }

    submitOrdersToDispatcherSector(
        payload: DispatcherSubmitOrdersToDispatcherSectorPayloadT
    ): Promise<AxiosResponse<void>> {
        return http.post(`${TAKE_URL}/dispatchers_sector_to_couiers`, payload)
    }

    submitOrdersToSector(
        payload: DispatcherSubmitOrdersToSectorPayloadT
    ): Promise<AxiosResponse<any>> {
        return http.post(`${TAKE_URL}/sector_to_courier`, payload)
    }

    submitOrderToCourier(
        payload: DispatcherSubmitOrderToCourierPayloadT
    ): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/dispatcher-admin/take/order-to-courier', payload)
    }

    submitCheckedOrders(
        payload: DispatcherSubmitCheckedOrdersPayloadT
    ): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/dispatcher-admin/take/orders/assign', payload)
    }

    changeOrderTakeDate(payload: ChangeOrderTakeDate): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/dispatcher-admin/take/order/change-date', payload)
    }

    changeOrderDeliveryDate(payload: ChangeDeliveryDatePayloadT): Promise<AxiosResponse<void>> {
        return http.put(
            `/cabinet/api/admin/invoices/${payload.invoice_id}/change-delivery-date`,
            payload
        )
    }

    getTakesList(params: ListsParamsT): Promise<AxiosResponse<DispatcherGetTakesListResponseT>> {
        return http.get('/cabinet/api/dispatcher-admin/takes/orders', { params })
    }

    deleteTake(take_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/dispatcher-admin/takes/orders/${take_id}`)
    }

    getDeliveryList(
        params: ListsParamsT
    ): Promise<AxiosResponse<DispatcherGetDeliveriesListResponseT>> {
        return http.get('/cabinet/api/dispatcher-admin/deliveries', { params })
    }

    deleteDelivery(delivery_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/dispatcher-admin/deliveries/${delivery_id}`)
    }

    getDeliveredInvoicesFile(
        fromDate: string,
        toDate: string
    ): Promise<AxiosResponse<DispatcherGetDeliveredInvoicesFileResponseT>> {
        const params = {
            fromDate,
            toDate,
        }

        return http.get('/cabinet/api/reports/delivery-invoice', { params, responseType: 'blob' })
    }

    approveDelivery(delivery_id: number, payload?: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(
            `/cabinet/api/dispatcher-admin/deliveries/${delivery_id}/approve-delivery`,
            payload
        )
    }

    getCouriersReports(
        dispatchers_sector_id: number
    ): Promise<AxiosResponse<DispatcherGetCouriersReportsResponseT>> {
        const params = {
            dispatchersSectorId: dispatchers_sector_id,
        }

        return http.get('/cabinet/api/dispatcher-admin/courier/report', { params })
    }

    enableAutoAssign(payload: DispatcherAutoAssignPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/dispatcher-admin/take-auto-assign/enable', payload)
    }

    closeDelivery(deliveryId: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/dispatcher-admin/deliveries/${deliveryId}/approve-pickup`, {
            deliveryId,
        })
    }

    disableAutoAssign(payload: DispatcherAutoAssignPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/dispatcher-admin/take-auto-assign/disable', payload)
    }

    loadWaitListStatuses(type = 1): Promise<AxiosResponse<DispatcherGetWaitListStatusesResponseT>> {
        const params = {
            type,
        }

        return http.get('/cabinet/api/wait-list-statuses', { params })
    }
}
